import * as API from './../base/api_service';
import * as serviceCallConfig from './../config/api_urls';

export var GET_ALL_FACILITY = 'GET_ALL_FACILITY';
export var CREATE_FACILITY = 'CREATE_FACILITY';
export var UPDATE_FACILITY = 'UPDATE_FACILITY';
export var GET_FACILITY_BY_ID = 'GET_FACILITY_BY_ID';
export var ADD_FACILITY_ADMIN = 'ADD_FACILITY_ADMIN';
export var GET_ADMIN_USER_BY_ID = 'GET_USER_BY_ID';
export var ACTIVATE_FACILITY_ADMIN = 'ACTIVATE_FACILITY_ADMIN';
export var DEACTIVATE_FACILITY_ADMIN = 'DEACTIVATE_FACILITY_ADMIN';
export var DEACTIVATE_FACILITY = 'DEACTIVATE_FACILITY';
export var FACILITY_IMAGE_UPLOAD = 'FACILITY_IMAGE_UPLOAD';
export var FACILITIES_LISTVIEW_TYPE = 'FACILITIES_LISTVIEW_TYPE';


export var RESEND_EXPIRED_LINK = 'RESEND_EXPIRED_LINK';
export var ResendLink = (data) => ({
    type: RESEND_EXPIRED_LINK,
    data: data
});

// need to remove, will be deprecated. now using "GET_FACILITIES_BY_SEARCH" api instead of this.
export var RequestResendLink = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.RESEND_EXPIRED_LINK),//endPoint
            '',//payLoad
            serviceCallConfig.RESEND_EXPIRED_LINK,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};



export var AddedFacility = (data) => ({
    type: CREATE_FACILITY,
    data: data
});


export var createfacility = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.CREATE_FACILITY),//endPoint
            data,//payLoad
            serviceCallConfig.CREATE_FACILITY,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken, //authKey
            '',//api_key
            '',//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};

export var facilityUpdate = (data) => ({
    type: UPDATE_FACILITY,
    data: data
});


export var updateFacility = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.UPDATE_FACILITY),//endPoint
            data,//payLoad
            serviceCallConfig.UPDATE_FACILITY,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken, //authKey
            '',//api_key
            '',//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};

export var FacilityDetails = (data) => ({
    type: GET_ALL_FACILITY,
    data: data
});

// need to remove, will be deprecated. now using "GET_FACILITIES_BY_SEARCH" api instead of this.
export var getAllfacilities = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.GET_ALL_FACILITY),//endPoint
            '',//payLoad
            serviceCallConfig.GET_ALL_FACILITY,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};


export var FacilityDetailsByID = (data) => ({
    type: GET_FACILITY_BY_ID,
    data: data
});
export var getAllfacilitiesById = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.GET_FACILITY_BY_ID),//endPoint
            '',//payLoad
            serviceCallConfig.GET_FACILITY_BY_ID,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};



export var addFacilityAdmin = (data) => ({
    type: ADD_FACILITY_ADMIN,
    data: data
});
export var createFaclityAdmin = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.ADD_FACILITY_ADMIN),//endPoint
            data,//payLoad
            serviceCallConfig.ADD_FACILITY_ADMIN,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken, //authKey
            '',//api_key
            '',//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};


export var getAdminUser = (data) => ({
    type: GET_ADMIN_USER_BY_ID,
    data: data
});

export var getAdminUserById = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.GET_ADMIN_USER_BY_ID),//endPoint
            '',//payLoad
            serviceCallConfig.GET_ADMIN_USER_BY_ID,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};



export var activate_facilty_admin = (data) => ({
    type: ACTIVATE_FACILITY_ADMIN,
    data: data
});


export var activate_admin = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.ACTIVATE_FACILITY_ADMIN),//endPoint
            data,//payLoad
            serviceCallConfig.ACTIVATE_FACILITY_ADMIN,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken, //authKey
            '',//api_key
            '',//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};


export var dectivate_facilty_admin = (data) => ({
    type: DEACTIVATE_FACILITY_ADMIN,
    data: data
});


export var deactivate_admin = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.DEACTIVATE_FACILITY_ADMIN),//endPoint
            data,//payLoad
            serviceCallConfig.DEACTIVATE_FACILITY_ADMIN,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken, //authKey
            '',//api_key
            '',//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};


export var deactive_facility = (data) => ({
    type: DEACTIVATE_FACILITY,
    data: data
});
export var deactiveFacility = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.DEACTIVATE_FACILITY),//endPoint
            '',//payLoad
            serviceCallConfig.DEACTIVATE_FACILITY,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};


export var uploadFacilityImage = (data, type, id) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_POST,
            dispatch,
            serviceCallConfig.get(serviceCallConfig.FACILITY_IMAGE_UPLOAD)+ "/"+ type + "/" + id,
            data,
            serviceCallConfig.FACILITY_IMAGE_UPLOAD,
            true, //true for multipart
            false, //authKey
            '',//api_key
            '',//getParams
            true, //multipart file
            "", //uniqueKey

        );

    };
};

// To set uploaded image response
export var upload_Facility_Image = (data) => ({
    type: FACILITY_IMAGE_UPLOAD,
    data: data
});

//get facilities by search api  method
export var getfacilitiesbySearch = (data) => {
    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.GET_FACILITIES_BY_SEARCH),//endPoint
            data,//payLoad
            serviceCallConfig.GET_FACILITIES_BY_SEARCH,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken, //authKey
            '',//api_key
            '',//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};

export var setFacilitiesListViewType = (data) => ({
    type: FACILITIES_LISTVIEW_TYPE,
    data: data
});


/** WEBPACK FOOTER **
 ** ./src/actions/facilities_actions.js
 **/